"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineDevicesSubscriptionBuzzerBuzzerHandlers = exports.OnlineDevicesSubscriptionBuzzerDispatcher = exports.OnlineDevicesSubscriptionBuzzerClient = void 0;
var Device_1 = require("./Device");
var services_vortex_1 = require("@playq/services-vortex");
var DeviceID_1 = require("./DeviceID");
var irt_1 = require("@playq/irt");
var InStatus = (function () {
    function InStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.status = Device_1.DeviceHelpers.deserialize(data.status);
    }
    Object.defineProperty(InStatus.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field status is not optional');
            }
            this._status = value;
        },
        enumerable: false,
        configurable: true
    });
    InStatus.prototype.serialize = function () {
        return {
            status: Device_1.DeviceHelpers.serialize(this.status)
        };
    };
    return InStatus;
}());
var InEvent = (function () {
    function InEvent(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.event = new services_vortex_1.ClientEvent(data.event);
    }
    Object.defineProperty(InEvent.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InEvent.prototype, "event", {
        get: function () {
            return this._event;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field event is not optional');
            }
            this._event = value;
        },
        enumerable: false,
        configurable: true
    });
    InEvent.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            event: this.event.serialize()
        };
    };
    return InEvent;
}());
var OnlineDevicesSubscriptionBuzzerClient = (function () {
    function OnlineDevicesSubscriptionBuzzerClient(transport) {
        this._transport = transport;
    }
    OnlineDevicesSubscriptionBuzzerClient.prototype.getPackageName = function () { return OnlineDevicesSubscriptionBuzzerClient.PackageName; };
    OnlineDevicesSubscriptionBuzzerClient.prototype.getClassName = function () { return OnlineDevicesSubscriptionBuzzerClient.ClassName; };
    OnlineDevicesSubscriptionBuzzerClient.prototype.getFullClassName = function () { return OnlineDevicesSubscriptionBuzzerClient.FullClassName; };
    OnlineDevicesSubscriptionBuzzerClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionBuzzerClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionBuzzerClient.prototype.status = function (status) {
        var _this = this;
        var __data = new InStatus();
        __data.status = status;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionBuzzerClient.ClassName, 'status', __data)
                .then(function () {
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionBuzzerClient.prototype.event = function (device, event) {
        var _this = this;
        var __data = new InEvent();
        __data.device = device;
        __data.event = event;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionBuzzerClient.ClassName, 'event', __data)
                .then(function () {
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionBuzzerClient.PackageName = 'net.playq.octopus2.devices';
    OnlineDevicesSubscriptionBuzzerClient.ClassName = 'OnlineDevicesSubscriptionBuzzer';
    OnlineDevicesSubscriptionBuzzerClient.FullClassName = 'net.playq.octopus2.devices.OnlineDevicesSubscriptionBuzzer';
    return OnlineDevicesSubscriptionBuzzerClient;
}());
exports.OnlineDevicesSubscriptionBuzzerClient = OnlineDevicesSubscriptionBuzzerClient;
var OnlineDevicesSubscriptionBuzzerDispatcher = (function () {
    function OnlineDevicesSubscriptionBuzzerDispatcher(marshaller, handlers) {
        this.marshaller = marshaller;
        this.handlers = handlers;
    }
    OnlineDevicesSubscriptionBuzzerDispatcher.prototype.getSupportedService = function () {
        return 'OnlineDevicesSubscriptionBuzzer';
    };
    OnlineDevicesSubscriptionBuzzerDispatcher.prototype.getSupportedMethods = function () {
        return OnlineDevicesSubscriptionBuzzerDispatcher.methods;
    };
    OnlineDevicesSubscriptionBuzzerDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "status": {
                var obj_1 = new InStatus(this.marshaller.Unmarshal(data, true));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.handlers.status(context, obj_1.status)
                            .then(function (res) {
                            resolve(_this.marshaller.Marshal(irt_1.Void.instance, true));
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "event": {
                var obj_2 = new InEvent(this.marshaller.Unmarshal(data, true));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.handlers.event(context, obj_2.device, obj_2.event)
                            .then(function (res) {
                            resolve(_this.marshaller.Marshal(irt_1.Void.instance, true));
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by OnlineDevicesSubscriptionBuzzerDispatcher."));
        }
    };
    OnlineDevicesSubscriptionBuzzerDispatcher.methods = [
        "status",
        "event"
    ];
    return OnlineDevicesSubscriptionBuzzerDispatcher;
}());
exports.OnlineDevicesSubscriptionBuzzerDispatcher = OnlineDevicesSubscriptionBuzzerDispatcher;
var OnlineDevicesSubscriptionBuzzerBuzzerHandlers = (function (_super) {
    __extends(OnlineDevicesSubscriptionBuzzerBuzzerHandlers, _super);
    function OnlineDevicesSubscriptionBuzzerBuzzerHandlers(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.handlers = _this;
        return _this;
    }
    OnlineDevicesSubscriptionBuzzerBuzzerHandlers.prototype.status = function (context, status) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionBuzzerBuzzerHandlers.prototype.event = function (context, device, event) {
        throw new Error('Not implemented.');
    };
    return OnlineDevicesSubscriptionBuzzerBuzzerHandlers;
}(OnlineDevicesSubscriptionBuzzerDispatcher));
exports.OnlineDevicesSubscriptionBuzzerBuzzerHandlers = OnlineDevicesSubscriptionBuzzerBuzzerHandlers;
//# sourceMappingURL=OnlineDevicesSubscriptionBuzzer.js.map